import { ReportChartFeedbackBaseType } from '@vision/ui/enums';
import { ReportChartConfiguration } from '@vision/ui/interfaces';
import { FeedbackBasedQuestionBasedMeasureRenderer, TreeMapChart1CompareRenderer } from '../../components';
import {
  DefaultReportChartThemeFont,
  DefaultReportChartThemeSeries,
  extendDefaultChartValidationSchema,
} from '../default-chart.config';
import { TreeMapChart1Measures } from './tree-map-chart1.measures';

export const TreeMapChart1DefaultConfiguration: ReportChartConfiguration = {
  validationSchema: extendDefaultChartValidationSchema({ withFeedbackBasedQuestionBased: true }),
  measures: TreeMapChart1Measures,
  compareRendererComponent: TreeMapChart1CompareRenderer,
  compareHeader: {
    labelKey: 'page-reports:compare',
    showIcon: false,
  },
  measureHeader: {
    labelKey: 'page-reports:measurement',
    showIcon: false,
  },
  measureRendererComponent: FeedbackBasedQuestionBasedMeasureRenderer,
  defaultFeedbackBasedQuestionBased: ReportChartFeedbackBaseType.FEEDBACK_BASED,
  customize: {
    active: (values) => values.selectedMeasure && values.selectedCompare.length > 0,
    transactionalDate: {
      active: false,
    },
    feedbackCount: {
      active: false,
    },
    limits: {
      upperLimitActive: false,
      upperLimit: 0,
      lowerLimitActive: false,
      lowerLimit: 0,
    },
  },
  defaultTheme: {
    active: (values) => values.selectedMeasure && values.selectedCompare.length > 0,
    title: {
      ...DefaultReportChartThemeFont,
      label: '',
    },
    series: {
      ...DefaultReportChartThemeSeries,
    },
    dataLabels: {
      ...DefaultReportChartThemeFont,
      active: false,
      displayFormat: 'auto',
      roundingMethod: 'default',
      hideFormatPosition: true,
    },
  },
};
